module.exports = __webpack_public_path__ + "img/company.5a566ccf.svg";